import { AddressItemType, PickupShop } from '@@types'
import { useTranslation } from 'react-i18next'

import { useAddressStore, useMutateDeleteAddress } from '@entities/Address'

import { useAuth } from '@features/auth'
import { useErrorInfoModal, useModalStore } from '@features/modal'

import Button from '@shared/ui/button'

import styles from './SelectBrandModal.module.scss'



export function DeleteAddressModal ({
  shop,
  onSuccess,
}: {
  shop: PickupShop | AddressItemType;
  onSuccess: () => void;
}) {
  const { t: tc } = useTranslation('common')
  const { t: tmd } = useTranslation('modalDelivery')
  const { t: te } = useTranslation('errors')
  const { openErrorInfoModal } = useErrorInfoModal()
  const { closeModal } = useModalStore()
  const { isAuthorized } = useAuth()
  const { removeAddress } = useAddressStore()
  const [ deleteAddressMutation ] = useMutateDeleteAddress()

  const handleDeleteShop = async (shop: PickupShop | AddressItemType) => {
    try {
      if (isAuthorized) {
        await deleteAddressMutation({ variables: { deleteAddressId: String(shop?.id) } })
        removeAddress(String(shop?.id))
      }
      else {
        removeAddress(String(shop?.id))
      }
    }
    catch (err) {
      console.error('Error saving address:', err)
      openErrorInfoModal({
        description: te('delete_address'),
      })
    }
    finally {
      closeModal('deleteAddress')
      onSuccess()
    }
  }

  return (
    <div className={styles.modal}>
      <p>
        {tmd('shop.delete_confirm')} <span>{shop?.address}</span>
      </p>
      <div className={styles.modal__buttons}>
        <Button onClick={() => handleDeleteShop(shop)}>{tc('yes')}</Button>
        <Button onClick={() => closeModal('deleteAddress')} theme="grey">
          {tc('no')}
        </Button>
      </div>
    </div>
  )
}
